import React, { useEffect, useState, useMemo } from "react";
import { useApi } from "../../hooks/useApi";
import DmeFolioStatusFilters from "./DmeFolioStatusFilters";
import DmeFolioStatusTable from "./DmeFolioStatusTable";
import DmeFolioStatusDetail from "./DmeFolioStatusDetail";
import { useMsal } from "@azure/msal-react";
import { API_URLS } from "../../api/apiUrls";

const DmeFolioStatusPage = () => {
    const { get } = useApi();
    const { accounts } = useMsal();
    const user = accounts[0];
    const userEmail = user?.username;

    const today = new Date().toISOString().slice(0, 10);

    const [filters, setFilters] = useState({
        chain: "",
        from: today,
        to: today,
    });

    const [userChains, setUserChains] = useState([]);
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [q, setQ] = useState("");

    const [selectedFolio, setSelectedFolio] = useState(null);
    const [detail, setDetail] = useState(null);

    // Cargar cadenas permitidas
    useEffect(() => {
        const fetchChains = async () => {
            if (!userEmail) return;
            try {
                const res = await get("chainsByUserEmail", { urlParams: { id: userEmail } });
                const chains = (res || []).map((c) => c.chain).filter(Boolean);
                setUserChains(chains);
            } catch {
                setUserChains([]);
            }
        };
        fetchChains();
    }, [userEmail, get]);

    const chainsToQuery = useMemo(() => {
        if (filters.chain && filters.chain.trim() !== "") return [filters.chain.trim()];
        return userChains;
    }, [filters.chain, userChains]);

    // Cargar lista de folios
    const loadList = async () => {
        if (!chainsToQuery.length) return;
        setLoading(true);
        try {
            const res = await get("ListaFoliosStatus", {
                params: {
                    chain: chainsToQuery.join(","),
                    from: filters.from,
                    to: filters.to,
                    page: 1,
                    pageSize: 20000,
                },
            });
            const arr = Array.isArray(res) ? res : res.items || [];
            setItems(arr);
            setPage(1);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userChains.length === 0) return;
        loadList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userChains]);

    useEffect(() => {
        if (chainsToQuery.length === 0) return;
        loadList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters.from, filters.to, chainsToQuery.join(",")]);

    const handleSearchFilters = (newFilters) => {
        setFilters((prev) => ({ ...prev, ...newFilters }));
    };

    const loadDetail = async (returnId, reference, branch) => {
        try {
            // Construir la URL directamente (m�s simple y sin ambig�edades)
            const url = `dme/log/folios/${returnId}/${encodeURIComponent(reference)}/${encodeURIComponent(branch)}`;
            const res = await get(url);
            console.log(url);
            setSelectedFolio({ returnId, reference, branch });
            setDetail(res);
        } catch (err) {
            console.error("Error loading folio detail:", err);
        }
    };

    const handleBack = () => {
        setSelectedFolio(null);
        setDetail(null);
    };

    const handleStatusUpdated = () => {
        loadList(); // Recargar lista
    };

    return (
        <div className="p-6">
            <h2 className="text-xl font-semibold mb-4">Consulta de Folios DME</h2>

            {!selectedFolio ? (
                <>
                    <DmeFolioStatusFilters
                        onSearch={handleSearchFilters}
                        current={{ ...filters }}
                        availableChains={userChains}
                    />

                    <DmeFolioStatusTable
                        items={items}
                        loading={loading}
                        onDetail={loadDetail}
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        q={q}
                        setQ={setQ}
                        onStatusUpdated={handleStatusUpdated}
                        chain={filters.chain}
                        from={filters.from}
                        to={filters.to} 
                    />
                </>
            ) : (
                <DmeFolioStatusDetail
                    data={detail}
                    folioData={selectedFolio}
                    onBack={handleBack}
                    onStatusUpdated={handleStatusUpdated}
                />
            )}
        </div>
    );
};

export default DmeFolioStatusPage;